import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  getParcelPassengerCitiesFailure,
  getParcelPassengerCitiesLoading,
  getParcelPassengerCitiesSuccess,
  updateProfileFailure,
  updateProfileLoading,
  updateProfileSuccess,
} from '../../ducks/ProfileSlice';

// Get Parcel Passenger Cities Handler
export function* handlerGetParcelPassengerCity(action: any): Generator<any, void, any> {
  try {
    yield put(getParcelPassengerCitiesLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getparcelpasseCities}`);
    
    if (response.success) {
      yield put(getParcelPassengerCitiesSuccess(response.data));
    } else {
      yield put(getParcelPassengerCitiesFailure(response.message || 'Failed to get parcel passenger cities'));
    }
  } catch (error: any) {
    yield put(getParcelPassengerCitiesFailure(error.message || 'Failed to get parcel passenger cities'));
  }
}

// Update Profile Handler
export function* handlerUpdateProfile(action: any): Generator<any, void, any> {
  try {
    yield put(updateProfileLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.updateuserprofile}`, action.payload);
    
    if (response.success) {
      yield put(updateProfileSuccess(response.data));
    } else {
      yield put(updateProfileFailure(response.message || 'Profile update failed'));
    }
  } catch (error: any) {
    yield put(updateProfileFailure(error.message || 'Profile update failed'));
  }
}
